var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralStorage = function SvgPGeneralStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M328.1,332.3c0-3.6-10.6-6.2-24-6.2s-24.4,2.5-24,6.2v103.8h48V332.3z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.1,
    y: 436.1,
    width: 40,
    height: 2,
    fill: "#C4C4C4"
  }))));
};
export default SvgPGeneralStorage;